import { Document } from 'app/src/services/welfareportal/membership-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const documentSchema: z.ZodType<Document> = z.object({
  documentId: z.string().max(36),
  type: z.string().max(255),
  name: z.string().max(255),
  url: z.string().max(255),
  body: z.string().max(255).optional(),
  title: z.string().max(255).optional(),
})
